import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { StyledFormGroup, Feedback } from './Common';

const LocationFields = ({
    register,
    detailsPath,
    sectionErrors,
    states,
    districts,
    selectedState
}) => {
    return (
        <Row>
            <StyledFormGroup as={Col} md="6">
                <Form.Label>State <span className="text-danger">*</span></Form.Label>
                <Form.Select
                    {...register(`${detailsPath}.state`)}
                    isInvalid={!!sectionErrors.state}
                >
                    <option value="">Select State</option>
                    {states.map(s => <option key={s.code} value={s.code}>{s.name}</option>)}
                </Form.Select>
                <Feedback error={sectionErrors.state} />
            </StyledFormGroup>

            <StyledFormGroup as={Col} md="6">
                <Form.Label>District <span className="text-danger">*</span></Form.Label>
                <Form.Select
                    {...register(`${detailsPath}.district`)}
                    disabled={!selectedState}
                    isInvalid={!!sectionErrors.district}
                >
                    <option value="">{selectedState ? "Select District" : "Select State first"}</option>
                    {selectedState && districts.length === 0 && <option value="" disabled>No districts found</option>}
                    {districts.map(d => <option key={d.name} value={d.name}>{d.name}</option>)}
                </Form.Select>
                <Feedback error={sectionErrors.district} />
            </StyledFormGroup>
        </Row>
    );
};

export default LocationFields;
